import { render } from "./Profile.vue?vue&type=template&id=52fabe96"
import script from "./Profile.vue?vue&type=script&lang=ts"
export * from "./Profile.vue?vue&type=script&lang=ts"

import "./Profile.vue?vue&type=style&index=0&id=52fabe96&lang=scss"
script.render = render

export default script